import type { ChartMarker } from '@finsim/charts';
import type { Project } from '@finsim/model';

/** The project's key dates as labelled lines on time charts (screen and report). */
export function keyDateMarkers(project: Pick<Project, 'keyDates'>): ChartMarker[] {
  return project.keyDates.map((k) => ({ id: k.id, index: k.month, label: k.name }));
}
